import { useState, useEffect } from 'react'
import { useTenant } from 'features/tenant/context'
import { GetTenantBanner } from 'interface/tenant'

import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Badge,
} from '@mui/material'

import { ErrorInfo } from 'components/controls/errorInfo'
import { useSideMenu } from './container'

type SideMenuProps = {
  sideMenuState: ReturnType<typeof useSideMenu>
}
export const SideMenu = ({
  sideMenuState: {
		sideBarOpen,
		setSideBarOpen,
    menuItems,
    menuCommands
  }
}: SideMenuProps) => {
  const tenant = useTenant()

  const [tenantBanner, setTenantBanner] = useState<string | undefined>()
  const [tenantResourceError, setTenantResourceError] = useState<Error | undefined>()

  useEffect(
    () => {
      GetTenantBanner(tenant.domain)
        .catch((reason) => setTenantResourceError(reason))
        .then((response) =>
          setTenantBanner(
            response ? URL.createObjectURL(response.blob) : undefined
          )
        )
    },
    [tenant]
  )
  return (
    <Drawer anchor="left" open={sideBarOpen} onClose={() => setSideBarOpen(false)}>
      <List>
        {tenantResourceError ? (
          <ErrorInfo error={tenantResourceError} padding={1} />
        ) : (
          <ListItem key="logo" disablePadding sx={{ justifyContent: 'center' }}>
            {tenantBanner && <img src={tenantBanner} alt={tenant.tenantName} />}
          </ListItem>
        )}

        {menuItems.map((itemGroup) => {
          return (
            <nav key={itemGroup.key}>
              <Divider />
              {itemGroup.commands.map((itemKey) => {
                const item = menuCommands[itemKey]
                return (
                  <ListItem key={itemKey} disablePadding>
                    <ListItemButton
                      onClick={() => {
                        item.callback()
                        setSideBarOpen(false)
                      }}
                      selected={item.selected}
                      disabled={item.disabled}
                    >
                      {item.icon ? (
                        <ListItemIcon>
                          <Badge badgeContent={item.badge} color="primary">
                            {item.icon}
                          </Badge>
                        </ListItemIcon>
                      ) : (
                        <></>
                      )}
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                )
              })}
            </nav>
          )
        })}
      </List>
    </Drawer>
  )
}
